@if (polDaten!=undefined && schadenfall!=undefined) {
  <mat-card class="PasuraSchadenfall mat-elevation-z4" >
    <mat-card-title  style="margin-bottom: 50px">
      <div class="flex-center" style="margin-top: 20px; ">
        Bearbeitung Schadenfall
      </div>
      <div class="flex-center" style="font-weight:normal; font-size:16px;  ">
        Police {{polDaten.PolicenNr}}	| {{polDaten.VNName}}
      </div>
    </mat-card-title>
    <hr style="width: 90%">
    <div class="flex-center" >Schadenfall {{schadenfall.SchadenFallID}} </div>
    <div class="flex-center" >{{schadenfall.Name}} {{schadenfall.NameZusatz}}</div>
    <!--
    <div class="flex-center" >Geboren {{toCHDateFormat(schadenfall.GebDat)}}</div>
    <div class="flex-center" >Chip/Pass {{schadenfall.PassChip}}</div>
    -->
    @if (workerWait) {
      <div class="flex-center">
        <mat-spinner></mat-spinner>
      </div>
    }
    @if (!workerWait) {
      <div>
        @if (!editSchadenfall) {
          <mat-card class="mat-elevation-z4" style="margin-top:25px">
            <mat-card-content>
              <div class="FormRow">
                <div class="ColA">Datum Ereignis</div>
                <div class="ColB">{{toCHDateFormat(schadenfall.DatumEreignis)}}
                  @if (schadenfall.PSF_Status==0 || globserv.APPLICATION=='PASURA' || PasuraBackOfficeUser) {
                    <div  class="editButton">
                      <button (click)="doEditSchadenfall()"  mat-icon-button aria-hidden="true" aria-label="Daten zum Schadenfall bearbeiten"  >
                        <mat-icon>edit</mat-icon>
                      </button>
                    </div>
                  }
                </div>
              </div>
              <div class="FormRow">
                <div class="ColA">Art des Ereignisses</div>
                <div class="ColB">{{schadenfall.Art}}</div>
              </div>
              <div class="FormRow" >
                <div class="ColA">Beschreibung</div>
                <div class="ColB" style="text-align: left;">{{schadenfall.Beschreibung}}</div>
              </div>
              <div class="FormRow" >
                <div class="ColA">Selbstbehalt</div>
                <div class="ColB">
                  <div class="ColB1">CHF</div>
                  <div class="ColB2">{{formatDecimal(schadenfall.Selbstbehalt)}}</div>
                </div>
              </div>
              @if (PasuraBackOfficeUser) {
                <div class="FormRow" >
                  <div class="ColA">Maximale Leistung</div>
                  <div class="ColB">
                    <div class="ColB1">CHF</div>
                    <div class="ColB2">{{formatDecimal(schadenfall.MaxLeistung)}}</div>
                  </div>
                </div>
              }
              @if (PasuraBackOfficeUser) {
                <div class="FormRow" >
                  <div class="ColA">Status</div>
                  <div class="ColB">{{schadenfall.StatusText}} (IDX={{schadenfall.AbrechnungIDX}}) </div>
                </div>
              }
              @if (PasuraBackOfficeUser && schadenfall.BexioBillStatus!=undefined && schadenfall.BexioBillStatus.length>0) {
                <div class="FormRow" >
                  <div class="ColA">Status-Bexio</div>
                  <div class="ColB">{{schadenfall.BexioBillStatus}} </div>
                </div>
              }
              <div class="FormRow" >
                <div class="ColA">Total eingereichte Leistungen</div>
                <div class="ColB">
                  <div class="ColB1">CHF</div>
                  <div class="ColB2">{{formatDecimal(schadenfall.TotalRG)}}</div>
                </div>
              </div>
              @if (PasuraBackOfficeUser) {
                <div class="FormRow">
                  <div class="ColA">Total Leistung</div>
                  <div class="ColB">
                    <div class="ColB1">CHF</div>
                    <div class="ColB2">{{formatDecimal(schadenfall.TotalVL)}}</div>
                  </div>
                </div>
              }
              @if (PasuraBackOfficeUser) {
                <div class="FormRow">
                  <div class="ColA">Total Auszahlung</div>
                  <div class="ColB">
                    <div class="ColB1">CHF</div>
                    <div class="ColB2">{{formatDecimal(schadenfall.TotalAZ)}}</div>
                  </div>
                </div>
              }
            </mat-card-content>
          </mat-card>
        }
        @if (editSchadenfall) {
          <mat-card class="mat-elevation-z4" style="margin-top:25px">
            <mat-card-content>
              <div  class="flex-center" style="margin-top: 20px;">
                <!--<span style="padding-top: 10px; margin-left: 5px; margin-right: 20px">Art des Schadenfalles</span> -->
                <mat-chip-listbox aria-label="Fish selection">
                  @if (('Behandlungskosten Kombi').includes(schadenfall.VProdukt)) {
                    <mat-chip-option  [selectable]="schadenfall.Art!='Krankheit'"		(selectionChange)="setArt('Krankheit')"   [selected]="schadenfall.Art.includes('Krankheit')" 	>Erkrankung</mat-chip-option>
                  }
                  @if (('Behandlungskosten Kombi').includes(schadenfall.VProdukt)) {
                    <mat-chip-option  [selectable]="schadenfall.Art!='Unfall'"			(selectionChange)="setArt('Unfall')"      [selected]="schadenfall.Art.includes('Unfall')"     >Unfall</mat-chip-option>
                  }
                  @if (schadenfall.Optionen.includes('Prophylaxe')) {
                    <mat-chip-option 					 [selectable]="schadenfall.Art!='Prophylaxe'"	(selectionChange)="setArt('Prophylaxe')"  [selected]="schadenfall.Art.includes('Prophylaxe')" >Prophylaxe</mat-chip-option>
                  }
                  @if (('Todesfall Kombi').includes(schadenfall.VProdukt)) {
                    <mat-chip-option 			 [selectable]="schadenfall.Art!='Todesfall'"		(selectionChange)="setArt('Todesfall')"   [selected]="schadenfall.Art.includes('Todesfall')"  >Todesfall</mat-chip-option>
                  }
                  @if (schadenfall.Optionen.includes('Invaliditaet')) {
                    <mat-chip-option 					 [selectable]="schadenfall.Art!='Invalidität'"	(selectionChange)="setArt('Invalidität')" [selected]="schadenfall.Art.includes('Invalidität')">Invalidität</mat-chip-option>
                  }
                </mat-chip-listbox>
              </div>
              <div class="flex-center" style="margin-top: 20px ; margin-bottom: 10px">
                <mat-form-field [ngClass]="schadenfall.DatumEreignis.length>9?'Feld':'FeldNOK'" style="width: 100%"  >
                  <mat-label >Datum des Ereignis</mat-label  >
                  <input
                    value="{{schadenfall.DatumEreignis}}"
                    matInput [matDatepicker]="picker"
                    (focus)="picker.open()"
                    (click)="picker.open()"
                    (dateInput)="schadenfall.DatumEreignis=globserv.getJsonDate($event.value)"
                    (dateChange)="schadenfall.DatumEreignis=globserv.getJsonDate( $event.value)"
                    >
                  <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                  <mat-datepicker  #picker></mat-datepicker>
                </mat-form-field>
              </div>
              <div class="FormRow">
                <mat-form-field  style="width: 100%;">
                  <mat-label>Beschreibung</mat-label>
                  <textarea #TextAreaBeschreibung matInput
                    [value]="schadenfall.Beschreibung"
                    (input)="onValueChange($event)"
                    placeholder=""
                  ></textarea>
                </mat-form-field>
              </div>
              @if (PasuraBackOfficeUser) {
                <div class="FormRow" >
                  <mat-form-field style="width: 100%;" >
                    <mat-label>Selbstbehalt</mat-label>
                    <input matInput [(ngModel)]="schadenfall.Selbstbehalt" name="Selbstbehalt">
                  </mat-form-field>
                </div>
              }
              <div class="FormRow" >
                <mat-form-field style="width: 100%;" >
                  <mat-label>IBAN für die Auzahlung</mat-label>
                  <input matInput [(ngModel)]="polDaten.IBAN" name="IBAN"  (ngModelChange)="checkIBAN()" >
                </mat-form-field>
                <mat-icon>{{(this.ibanOK?"thumb_up":"thumb_down")}}</mat-icon>
              </div>
              @if (isChangedSchadenfall()) {
                <button mat-flat-button color="primary" (click)="saveSchadenfallDaten()" [disabled]="!SchadenfallDatenOK()"   >
                  speichern
                </button>
              }
              <button  mat-flat-button color="primary" (click)="cancelEditSchadenfall()"  style="margin-left: 10px" >
                abbrechen
              </button>
              @if (schadenfallOrg=='') {
                <button  mat-flat-button color="primary" (click)="showDeleteSchadenfallToaster()"  style="margin-left: 10px" >
                  Schadenfall löschen
                </button>
              }
            </mat-card-content>
          </mat-card>
        }
        @if (schadenfall!=undefined && schadenfall.Rechnungen!=undefined && schadenfall.Rechnungen.length>0) {
          <div>
            <div style="margin-top: 25px; font-weight:normal; font-size:16px; line-height:120% ">Eingereichte Rechungen / Dokumente </div>
            <mat-card>
              <mat-card-content>
                <table mat-table  #tableDocument	[dataSource]='schadenfall.Rechnungen' class="mat-elevation-z8"  [multiTemplateDataRows]="true" >
                  @for (column of displColRechnungen; track column) {
                    <ng-container matColumnDef="{{column.Name}}">
                      <th mat-header-cell *matHeaderCellDef  [ngClass]="{'myRechts': column.Number}"> {{column.Titel}} </th>
                      <td mat-cell *matCellDef="let element; let idx=dataIndex"
                        [ngClass]="{'SchadenfallNoEdit': element.Status>=2 , 'myRechts': column.Number, 'myHidden': getColSpan(element, column.Name)==0}"
                        [attr.colspan]="getColSpan(element, column.Name)"
                        >
                        @if (element.Typ=='Unterlagen' || element.Typ=='Tierarztbericht') {
                          <div>
                            @if (column.Name=='DatumRechnungFormated') {
                              <div>
                                {{element[column.Name]}}
                              </div>
                            }
                            @if (column.Name=='Leistungserbringer') {
                              <div >
                                {{element.Bemerkung}}
                              </div>
                            }
                            @if (column.Name=='Status') {
                              <div >
                                <button  mat-icon-button aria-hidden="true"  (click)="showDocument(element)">
                                  <mat-icon>image_search</mat-icon>
                                </button>
                                <!--
                                <button *ngIf="PasuraBackOfficeUser && element.Typ!='Rechnung'"  mat-icon-button aria-hidden="true"  (click)="setDocEdit(element)">
                                  <mat-icon>edit</mat-icon>
                                </button>
                                -->
                                <button  mat-icon-button aria-hidden="true">
                                  <mat-icon>{{ (element.Status<2?"edit":"lock") }}edit</mat-icon>
                                </button>
                              </div>
                            }
                          </div>
                        }
                        @if (element.Typ=='Rechnung') {
                          <div>
                            @if (column.Name=='Status') {
                              <div>
                                @if (element.FileName!=undefined && element.FileName.length>1) {
                                  <button mat-icon-button aria-hidden="true"  (click)="showDocument(element)">
                                    <mat-icon>image_search</mat-icon>
                                  </button>
                                }
                                <button  mat-icon-button aria-hidden="true">
                                  <mat-icon>{{ (element.Status<2?"edit":"lock") }}edit</mat-icon>
                                </button>
                              </div>
                            }
                            @if (column.Name!='Status') {
                              <div>{{element[column.Name]}}</div>
                            }
                          </div>
                        }
                      </td>
                    </ng-container>
                  }
                  <ng-container matColumnDef="expandedDetail" >
                    <td mat-cell  *matCellDef="let element; index as rgIDX" [attr.colspan]="displColRechnungen.length" class="row_selected">
                      @if (element.PSR_ID==tabExpPSR_ID) {
                        <div style="width: 100%">
                          <mat-form-field style="width: 90%">
                            <mat-label>Leistungserbringer</mat-label>
                            <input matInput  [(ngModel)]="element.Leistungserbringer"  name="rgLeistungserbringer">
                          </mat-form-field>
                          <mat-form-field style="width: 70%">
                            <mat-label >Datum der Rechnung</mat-label  >
                            <input
                              value="{{element.DatumRechnung}}"
                              matInput [matDatepicker]="picker"
                              (focus)="picker.open()"
                              (click)="picker.open()"
                              (dateInput)="element.DatumRechnung=globserv.getJsonDate($event.value)"
                              (dateChange)="element.DatumRechnung=globserv.getJsonDate( $event.value)"
                              >
                            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                            <mat-datepicker  #picker></mat-datepicker>
                          </mat-form-field>
                          <mat-form-field style="width: 20%" >
                            <mat-label>Betrag Rechnung</mat-label>
                            <input matInput  [(ngModel)]="element.BetragRechnung"  name="rgBetrag">
                          </mat-form-field>
                          <mat-form-field  style="width: 100%;">
                            <mat-label>Bemerkung</mat-label>
                            <textarea #TextAreaBeschreibungRG matInput
                              [value]="element.Bemerkung"
                              [(ngModel)]="element.Bemerkung"
                              name="rgBemerkung"
                              placeholder=""
                            ></textarea>
                          </mat-form-field>
                          @if (PasuraBackOfficeUser) {
                            <div>
                              <div style="margin-top:10px; margin-bottom: 2px;">Abrechnung</div>
                              @for (pos of element.Positionen; track pos) {
                                <div style="width: 100%">
                                  <form >
                                    <mat-form-field style="width: 70%">
                                      <mat-label>Beschreibung</mat-label>
                                      <input matInput  [(ngModel)]="pos.Text"  name="posText">
                                    </mat-form-field>
                                    <mat-form-field style="width: 20%" >
                                      <mat-label>Betrag</mat-label>
                                      <input matInput  [(ngModel)]="pos.Betrag"  name="posBetrag">
                                    </mat-form-field>
                                  </form>
                                </div>
                              }
                              <mat-label>Rechnung/Beleg auswechseln</mat-label>
                              <input type="file" class="file-input" (change)="onFileSelected($event)" #fileUpload>
                              <div style="margin-bottom: 20px">
                                <button mat-mini-fab color="primary" style="margin-right: 20px;top: 8px"
                                  (click)="fileUpload.click()">
                                  <mat-icon>attach_file</mat-icon>
                                </button>
                                @if (DocumentFile!=undefined) {
                                  <span>{{DocumentFile.name}}</span>
                                }
                              </div>
                            </div>
                          }
                          @if (PasuraBackOfficeUser && element.Typ=='Rechnung') {
                            <button mat-flat-button color="primary" (click)="addPosition(element.PSF_ID,element.PSR_ID)" style="width: 100%; margin-top: 10px;"  >
                              Abrechnungsposition hinzufügen
                            </button>
                          }
                          <button mat-flat-button color="primary" (click)="savePositionExpPSR()" style="width: 100%; margin-top: 10px; margin-bottom: 5px;"  >
                            Speichern
                          </button>
                        </div>
                      }
                    </td>
                  </ng-container>
                  <tr mat-header-row *matHeaderRowDef="displColRechnungenName"></tr>
                  <tr mat-row *matRowDef="let row; columns: displColRechnungenName;"
                    (click)="savePosition(row)">
                  </tr>
                  <tr mat-row *matRowDef="let row;	columns: ['expandedDetail']"
                    class='tabPferd-detail-row'
                    [@detailExpand]="row.PSR_ID == tabExpPSR_ID ? 'expanded' : 'collapsed'">
                  </tr>
                </table>
                @if (PasuraBackOfficeUser && schadenfall.ExistInfos ) {
                  <div>
                    @if (schadenfall.PSF_Status<2 && schadenfall.AbrechnungOffen) {
                      <button mat-flat-button color="primary" (click)="createAbrechnungDocX()" style="width: 100%; margin-top: 10px;" [disabled]="tabExpPSR_ID>0" >
                        <span>Abrechnung{{ schadenfall.ExistAbrechnungDocX?"-DocX überschreiben":"-DocX erstellen" }}</span>
                      </button>
                    }
                    @if (schadenfall.ExistBexioFile==true && 'PAID SENT'.includes(schadenfall.BexioBillStatus)==false && schadenfall.ExistAbrechnungPDF==true) {
                      <button
                        style="margin-top: 10px;"
                        [disabled]="schadenfall.BexioBillStatus=='SENT'"
                        mat-flat-button color="primary"
                        (click)="createBexioZahlung()"
                        style="width: 100%; margin-top: 10px;"  >
                        <span>{{ schadenfall.ExistBexioBill?"Update Bexio-Zahlung":"erstelle Bexio-Zahlung" }}</span>
                      </button>
                    }
                  </div>
                }
                @if (PasuraBackOfficeUser && globserv.Login.LoginStatus==true && schadenfall.ExistInfos==true) {
                  <button  mat-icon-button [matMenuTriggerFor]="menuSchadenfall" >
                    <mat-icon>more_vert</mat-icon>
                  </button>
                }
                <mat-menu #menuSchadenfall="matMenu">
                  @if (schadenfall.ExistInfos==true && 'PAID SENT'.includes(schadenfall.BexioBillStatus)==false && schadenfall.ExistAbrechnungPDF==true ) {
                    <button mat-menu-item    (click)="createAbrechnungDocX(true)"  >
                      <mat-icon>forward</mat-icon>
                      <span>nur PDF erstellen</span>
                    </button>
                  }
                  @if (schadenfall.PSF_Status > 1 && schadenfall.ExistInfos==true && 'PAID SENT'.includes(schadenfall.BexioBillStatus)==false ) {
                    <button mat-menu-item    (click)="schadenfallSetStatus(1)"  >
                      <mat-icon>forward</mat-icon>
                      <span>letzte Abrechnung nochmals bearbeiten</span>
                    </button>
                  }
                  @if (schadenfall.PSF_Status > 0 ) {
                    <button mat-menu-item    (click)="schadenfallSetStatus(0,true)"  >
                      <mat-icon>forward</mat-icon>
                      <span>Schadenfall wieder öffnen</span>
                    </button>
                  }
                  @if (schadenfall.PSF_Status == 0) {
                    <button mat-menu-item    (click)="schadenfallSetStatus(1)"  >
                      <mat-icon>forward</mat-icon>
                      <span>Schadenfall zum Abrechnen markieren</span>
                    </button>
                  }
                  @if (schadenfall.PSF_Status ==1) {
                    <button mat-menu-item  (click)="schadenfallSetStatus(2)"  >
                      <mat-icon>forward</mat-icon>
                      <span>Schadenfall als Abgerechnet markieren</span>
                    </button>
                  }
                </mat-menu>
              </mat-card-content>
            </mat-card>
          </div>
        }
        @if (tabExpPSR_ID <=0 && !editSchadenfall && schadenfall.Rechnungen!=undefined && schadenfall.Rechnungen.length>0 && !PasuraBackOfficeUser && schadenfall.PSF_Status==0) {
          <div style="margin-top: 15px" >
            <button mat-flat-button color="primary" (click)="schadenfallAbschliessen()" style="width: 95%; margin-top: 10px;" [disabled]="tabExpPSR_ID>0" >
              Schadenfall voraussichtlich abgeschlossen, bitte Abrechnen.
            </button>
          </div>
        }
        @if (tabExpPSR_ID <=0 &&  !editSchadenfall && schadenfall.Rechnungen!=undefined &&  schadenfall.PSF_Status==0 ) {
          <div style="margin-top: 15px" >
            <mat-expansion-panel  [expanded]="schadenfall.Rechnungen.length==0" #panelNewSchadenfall >
              <mat-expansion-panel-header>
                <mat-panel-title> {{docEdit?"Rechnung / Dokument editieren":"Neue Rechnung / Dokument einreichen"}}
                </mat-panel-title>
              </mat-expansion-panel-header>
              @if (!docEdit) {
                <div class="FormRow">
                  <mat-form-field style="width: 100%" >
                    <mat-label>Art des Dokumentes</mat-label>
                    <mat-select [(value)]="newDocument.Typ"  [(ngModel)]="newDocument.Typ" >
                      <mat-option value="Rechnung">Rechnung</mat-option>
                      <mat-option value="Tierarztbericht">Tierarztbericht</mat-option>
                      <mat-option value="Unterlagen">Unterlagen zum Schadenfall</mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
              }
              @if (newDocument.Typ=='Rechnung') {
                <div>
                  <div class="FormRow">
                    <mat-form-field   [ngClass]="newDocument.Leistungserbringer.length>4?'Feld':'FeldNOK'" style="width:100%">
                      <mat-label>Name des Leistungserbringers / Rechnungsstellers</mat-label>
                      <input matInput [(ngModel)]="newDocument.Leistungserbringer"  name="Leistungserbringer" (change)="validateFormData()">
                    </mat-form-field>
                  </div>
                  <div  >
                    <mat-form-field [ngClass]="newDocument.Datum.length>9?'Feld':'FeldNOK'" style="width: 100%"  >
                      <mat-label >Datum der Rechnung</mat-label  >
                      <input
                        matInput [matDatepicker]="picker"
                        (focus)="picker.open()"
                        (click)="picker.open()"
                        (dateInput)="setDatum( $event)"
                        (dateChange)="setDatum( $event)"
                        >
                      <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                      <mat-datepicker #picker></mat-datepicker>
                    </mat-form-field>
                  </div>
                  <div>
                    <mat-form-field [ngClass]="(newDocument.Betrag>0  && isNaN_(newDocument.Betrag))?'Feld':'FeldNOK'" style="width: 100%"  >
                      <mat-label >Rechnungsbetrag</mat-label  >
                      <input type="number" matInput [(ngModel)]="newDocument.Betrag"  name="Betrag" (change)="validateFormData()">
                    </mat-form-field>
                  </div>
                </div>
              }
              <mat-form-field  style="width: 100%;">
                <mat-label>Bemerkung</mat-label>
                <textarea #TextAreaBeschreibungRG matInput
                  [value]="newDocument.Bemerkung"
                  (input)="onValueChangeRG($event)"
                  [(ngModel)]="newDocument.Bemerkung"
                  name="Bemerkung"
                  placeholder=""
                ></textarea>
              </mat-form-field>
              <input type="file" class="file-input" (change)="onFileSelected($event)" #fileUpload>
              <div style="margin-bottom: 20px">
                <button mat-mini-fab color="primary" style="margin-right: 20px;top: 8px"
                  (click)="fileUpload.click()">
                  <mat-icon>attach_file</mat-icon>
                </button>
                {{ DocumentFile?DocumentFile.name:"Sie haben noch keine Datei angehängt"}}
              </div>
              <button  mat-flat-button color="primary" (click)="sendNewDocument(docEdit)"  [disabled]="!newDocument.OK" >
                {{docEdit?"Rechnung/Dokument spreichern":"Rechnung/Dokument einreichen"}}
              </button>
            </mat-expansion-panel>
          </div>
        }
      </div>
    }
  </mat-card>
}

